/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ArtistAliasCreateSourceIds } from './ArtistAliasCreateSourceIds';
import {
    ArtistAliasCreateSourceIdsFromJSON,
    ArtistAliasCreateSourceIdsFromJSONTyped,
    ArtistAliasCreateSourceIdsToJSON,
} from './ArtistAliasCreateSourceIds';

/**
 * 
 * @export
 * @interface ArtistAliasCreate
 */
export interface ArtistAliasCreate {
    /**
     * 
     * @type {string}
     * @memberof ArtistAliasCreate
     */
    stageName: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistAliasCreate
     */
    manualStageName?: boolean;
    /**
     * 
     * @type {ArtistAliasCreateSourceIds}
     * @memberof ArtistAliasCreate
     */
    sourceIds: ArtistAliasCreateSourceIds;
}

/**
 * Check if a given object implements the ArtistAliasCreate interface.
 */
export function instanceOfArtistAliasCreate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "sourceIds" in value;

    return isInstance;
}

export function ArtistAliasCreateFromJSON(json: any): ArtistAliasCreate {
    return ArtistAliasCreateFromJSONTyped(json, false);
}

export function ArtistAliasCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistAliasCreate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stageName': json['stageName'],
        'manualStageName': !exists(json, 'manualStageName') ? undefined : json['manualStageName'],
        'sourceIds': ArtistAliasCreateSourceIdsFromJSON(json['source_ids']),
    };
}

export function ArtistAliasCreateToJSON(value?: ArtistAliasCreate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stageName': value.stageName,
        'manualStageName': value.manualStageName,
        'source_ids': ArtistAliasCreateSourceIdsToJSON(value.sourceIds),
    };
}

